import { render, staticRenderFns } from "./pi-revenue-data.vue?vue&type=template&id=4ced1a23&"
import script from "./pi-revenue-data.vue?vue&type=script&lang=ts&"
export * from "./pi-revenue-data.vue?vue&type=script&lang=ts&"
import style0 from "./pi-revenue-data.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports